export default __webpack_public_path__ + "95df76e2007ffd5e18ea98c5ed218918.mp3";